// extracted by mini-css-extract-plugin
export default {"Tabs":"Sandbox_Tabs__yLhR8"};